// Match Cards - Movement — over/under cards odds drift (Phase 3 → M2 wave 10).
// Identical to Match Goals - Movement but for the cards movement dataset + the
// `cmm-wrapper` class; thin wrapper over <MovementChart>. Fallback line is
// "over_1.5".
//
// The series/labels/offsets now arrive from app-api via `useWidgetData` as one
// `GoalsCardsMovementPayload` envelope `{ series, labels, bkOffsets }` (was the
// getCardsMovementData / getCardsMovementLabels / getBkOffsets getters); the
// controls reshape the fetched payload client-side (no refetch).

import { shapeMovement } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import MovementChart from "./MovementChart.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface CardsMarketMovementProps {
  fixture: string;
  bookmaker?: string | null;
  scope?: string | null;
  /** Market line toggle, e.g. "under_0.5"; defaults to "over_1.5". */
  marketLine?: string | null;
}

export default function CardsMarketMovement({
  fixture,
  bookmaker,
  scope,
  marketLine,
}: CardsMarketMovementProps) {
  const fix = fixture || "Arsenal v Everton";
  const { data, isPending, isError, refetch } = useWidgetData(
    "match-cards-movement",
    useFixtureKey(fix)
  );
  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const key = marketLine || "over_1.5";
  const series = data?.series ?? {};
  const fixData = series[fix] ?? series["Arsenal v Everton"];
  const scopeData = fixData?.[scope || "Match"] ?? fixData?.["Match"];
  const base = scopeData?.[key] ?? scopeData?.["over_1.5"] ?? [];
  const offset = (data?.bkOffsets ?? {})[bookmaker || "Pinnacle"] ?? 0;
  const label = (data?.labels ?? {})[key] ?? key;
  const shape = shapeMovement(base, offset, label);
  if (!shape) return <div className="cmm-wrapper bm-wrapper" />;
  return <MovementChart wrapperClass="cmm-wrapper" shape={shape} />;
}
